export default __webpack_public_path__ + "static/media/21.35caa6b4.jpg";